export const FEATURES = [
  {
    slug: 'self-serve-edits',
    metaTitle: 'Let Customers Edit Shopify Orders After Checkout | Account Editor',
    metaDescription:
      'Let customers edit Shopify orders after checkout, including sizes, colors, quantities, variants, and addresses, without contacting customer support.',
    icon: 'ph-pencil-simple-line',
    label: 'Self-Serve Edits',
    title: 'Customers fix their own orders.',
    desc: 'Sizes, colors, quantities, variants, addresses — all editable from the order confirmation. No tickets, no waiting, no manual ops.',
    imgSrc: '/images/self-serve-edits.webp',
    showcaseSrc: '/images/self-serve-edits-preview.webp',
    bullets: [
      'Editable: contact info, shipping address, product variant, quantity, and add-ons',
      'Configurable edit windows by collection, SKU, or fulfillment status',
      'Granular rules for what stays editable until pick, pack, or ship',
    ],
  },
  {
    slug: 'cancel-deflection',
    metaTitle: 'Prevent Shopify Order Cancellations | Account Editor',
    metaDescription:
      'Reduce Shopify order cancellations by offering store credit, free upgrades, and alternatives at the moment customers consider cancelling.',
    icon: 'ph-shield-check',
    label: 'Cancel Deflection',
    title: 'Save cancels before refunds.',
    desc: 'Offer store credit, free upgrades, or smart alternatives the moment a customer hits "cancel" — and recover up to 38% of would-be refunds.',
    imgSrc: '/images/cancel-deflection.webp',
    showcaseSrc: '/images/cancel-deflection-preview.webp',
    bullets: [
      'Store-credit offers with configurable bonus tiers',
      'Free-upgrade and bundle-swap deflection paths',
      'Reason-code analytics so you fix the root cause, not just the symptom',
    ],
  },
  {
    slug: 'post-purchase-upsells',
    metaTitle: 'Increase Shopify AOV With Post-Purchase Upsells | Account Editor',
    metaDescription:
      'Increase Shopify average order value with post-purchase upsells that let customers add products after checkout, before fulfilment begins.',
    icon: 'ph-trend-up',
    label: 'Post-Purchase Upsells',
    title: 'One-click add-ons, same box.',
    desc: 'Land upsells after checkout but before the warehouse picks. AOV lifts 9–17% out of the box — no extra shipping, no friction.',
    imgSrc: '/images/post-purchase-upsells.webp',
    showcaseSrc: '/images/post-purchase-upsells-preview.webp',
    bullets: [
      'One-click upsells charged to the original payment method',
      'Bundle upsells with auto-discount when added pre-fulfillment',
      'Incremental-lift dashboard finance can sign off on',
    ],
  },
  {
    slug: 'operations-analytics',
    metaTitle: 'Track Shopify Order & Sales | Account Editor',
    metaDescription:
      'Track order edits, cancellation deflection, recovered revenue, and AOV lift in one Shopify analytics dashboard to measure post-purchase performance.',
    icon: 'ph-chart-line-up',
    label: 'Operations Analytics',
    title: 'Dashboards finance can trust.',
    desc: 'Edit volume, deflection rate, recovered revenue, AOV lift — all in one dashboard, reconciled to your Shopify ledger.',
    imgSrc: '/images/operations-analytics.webp',
    showcaseSrc: '/images/operations-analytics-preview.webp',
    bullets: [
      'Reconciled-to-ledger recovered revenue reporting',
      'Cohort views by traffic source, SKU, and edit type',
      'CSV exports and webhook triggers for downstream BI',
    ],
  },
  {
    slug: 'address-validation',
    metaTitle: 'Prevent Shipping Errors With Shopify Address Validation | Account Editor',
    metaDescription:
      'Validate and correct Shopify shipping addresses to catch typos before fulfilment, reduce delivery issues, and prevent avoidable shipping errors.',
    icon: 'ph-map-pin-area',
    label: 'Address Validation',
    title: 'Catch bad addresses early.',
    desc: 'Google-validated address corrections on every order. Customers fix typos at checkout — not after the package gets stuck at a sortation hub.',
    imgSrc: '/images/address-validation.webp',
    showcaseSrc: '/images/address-validation-preview.webp',
    bullets: [
      'Google-powered validation with confidence scoring',
      'Auto-suggest corrections that customers can accept in one tap',
      'Block obvious failures before they hit your 3PL',
    ],
  },
];

export const getFeatureBySlug = (slug) => FEATURES.find((f) => f.slug === slug);
